(function () {
	'use strict';

	angular.module('dcApp').component('projectVersionsSelector', {
		bindings: {
			projectId: '<',
			currentProjectVersion: '=',
			isGenericDataMode: '<',
			onSelect: '&',
		},
		controller: [
			'$rootScope',
			'$scope',
			'$document',
			'$element',
			'ProjectService',
			'toaster',
			'gettextCatalog',
			ProjectVersionsSelectorController,
		],
		controllerAs: 'vm',
		templateUrl:
			'directives/project/project-versions-selector/project-versions-selector.html',
	});

	// --- Controller function ---
	function ProjectVersionsSelectorController(
		$rootScope,
		$scope,
		$document,
		$element,
		ProjectService,
		toaster,
		gettextCatalog
	) {
		var vm = this;

		// --- Component Properties ---
		vm.showDropdown = false;
		vm.dropdownLoading = false;
		vm.selectedIsActive = false;
		vm.versions = [];
		vm.fetchVersions = fetchVersions;
		vm.toggleDropdown = toggleDropdown;
		vm.activateVersion = activateVersion;
		vm.selectVersion = selectVersion;

		const toasterPopSuccessTitle = gettextCatalog.getString(
			'project.version.activate.success.title'
		);
		const toasterPopSuccessMessage = gettextCatalog.getString(
			'project.version.activate.success.message'
		);

		vm.$onChanges = function (changes) {
			if (changes.projectId && changes.projectId.currentValue) {
				vm.fetchVersions();
			}
		};

		vm.$onInit = function () {
			$scope.$on('update:project:selection', function (event, data) {
				vm.currentProjectVersion = data || $rootScope.currentProjectVersion;
			});
		};

		vm.$onDestroy = function () {
			$document.off('click', onDocumentClick);
		};

		// --- Private Functions ---

		function fetchVersions() {
			if (!vm.projectId) {
				return;
			}
			vm.dropdownLoading = true;
			vm.versions = [];
			ProjectService.getProjectVersions(vm.projectId)
				.then(function (response) {
					vm.versions = response.data;
					checkIfSelectedIsActive();
				})
				.finally(function () {
					vm.dropdownLoading = false;
				});
		}

		function toggleDropdown() {
			vm.showDropdown = !vm.showDropdown;
			if (vm.showDropdown) {
				vm.fetchVersions();
				$document.on('click', onDocumentClick);
			} else {
				$document.off('click', onDocumentClick);
			}
		}

		function activateVersion(version, e) {
			e.stopPropagation();
			e.preventDefault();
			if (!version.is_default_version) {
				ProjectService.activateProjectVersion(version.id).then(function (
					response
				) {
					toaster.pop(
						'success',
						toasterPopSuccessTitle,
						toasterPopSuccessMessage
					);
					vm.versions.forEach(function (v) {
						v.is_default_version = v.id === version.id;
					});
					checkIfSelectedIsActive();
				});
			}
		}

		function selectVersion(version) {
			if (!version.is_available) {
				return;
			}

			if (vm.onSelect) {
				vm.toggleDropdown();
				vm.onSelect({
					version: version,
				});
			}
		}

		function checkIfSelectedIsActive() {
			const current = vm.versions.find(function (v) {
				return v.id == vm.projectId;
			});
			vm.selectedIsActive = current && current.is_default_version;
		}

		function onDocumentClick(event) {
			if (!$element[0].contains(event.target)) {
				$scope.$apply(function () {
					vm.showDropdown = false;
					$document.off('click', onDocumentClick);
				});
			}
		}
	}
})();
